import "./MemberChart.css";
import React from 'react';
import ReactApexChart from "react-apexcharts";

const MemberChart = ({ data }) => {
  const chartData = [];

  for (const item in data) {
    chartData[item] = data[item];
  }

  const months = chartData.map((item) => item.month);
  const datas = chartData.map((item) => item.count);

  const series = [
    {
      name: "Members",
      data: datas.reverse(),
    },
  ];
  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        color: "#258cf4",
        top: 18,
        left: 7,
        blur: 10,
        opacity: 0.2,
      },
    },
    legend: {
      show: true,
      position: "bottom",
    },
    series: series,
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    grid: {
      row: {
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: months.reverse(),
    },
    yaxis: {
      min: 0,
      max: 100,
      tickAmount: 5,
      labels: {
        formatter: function (val) {
          return val.toFixed(0) + "%";
        },
      },
    },
  };

  return (
    <div>
      <ReactApexChart options={options} series={options.series} type="line" />
      <div className="member-div">
        <span className="member-box"></span>
        <div className="member">Member</div>
      </div>
    </div>
  );
};

export default MemberChart;
